import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaCinemaUtility from '@sparta.global.utilities/cinema-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import _ from '@sparta.global.vendors/lodash';
import Handlebars from '@sparta.global.vendors/handlebars';

/**
 * Utility modal-utility
 * @description Modal utility
 * @copyright 2019-9-13
 * @file
 */

const CSS_SELECTORS = {
  videoContainer: '.modal-container__layer',
  spaCinema: '.spa-cinema',
  spartaContainer: '[data-sparta-container]'
};

/**
 * @class ModalUtility
 */
class ModalUtility {
  /**
   * @method constructor
   * @description initializes new instance of ModalUtility Class
   */
  constructor() {
    this.videoLayers = {};
    this.isFirstLoad = true;
    this.addCustomInterstitialContent();
  }

  /**
   * Call modal functions based on the content provided
   * @param {Object} content - jcr content
   * @return {void}
   */
  init(content) {
    if (!content) {
      return;
    }
    const {
      layerContent
    } = content;
    if (layerContent && layerContent.videoModalLayer) {
      this.appendVideoLayer(layerContent);
    }
  }

  /**
   * Add custom interstitial content retrieved from `rel` `addContent` data option of the link
   * @return {void}
   */
  addCustomInterstitialContent() {
    spartaEventsUtility.sub(spartaUILayersUtility.EVENTS.MODAL_OPENED, event => {
      const {
        contentId,
        addContent
      } = event.data;
      if (contentId) {
        const layersCta = document.querySelector(`[rel="${contentId}"]`);
        if (layersCta) {
          const {
            options
          } = layersCta.dataset;
          try {
            const jsonData = JSON.parse(options);
            if (jsonData && jsonData.addContent) {
              addContent(jsonData.addContent);
            }
          } catch (e) {
            console.error(e);
          }
        }
      }
    });
  }

  /**
   * Append video layer at the end of the main sparta container
   * @param {Object} layer - modal layer data
   * @returns {void}
   */
  appendVideoLayer(layer) {
    if (this.isFirstLoad) {
      this.subVideoModalEvents();
      this.spartaContainerEl = document.querySelector(CSS_SELECTORS.spartaContainer);
      this.isFirstLoad = false;
    }
    const modalLayerId = layer.id;
    this.videoLayers[modalLayerId] = layer;
    const templateString = `
    {{#layerContent this.videoModalLayer}}
    <div class="modal-container__layer">
      {{#if this.videoModalLayer.video}}
        {{{cinemaHelper this.videoModalLayer.video}}}
      {{/if}}
    </div>
  {{/layerContent}}`;
    const template = Handlebars.compile(templateString);
    requestAnimationFrame(() => {
      this.spartaContainerEl.insertAdjacentHTML('beforeend', template(_.defaultsDeep(layer)));
    });
  }

  /**
   * Subscribe to modal layer events related to videos
   * @returns {void}
   */
  subVideoModalEvents() {
    spartaEventsUtility.sub(spartaUILayersUtility.EVENTS.MODAL_OPENED, resp => {
      const modalLayerId = resp.data.contentId;
      if (modalLayerId) {
        spartaCinemaUtility.init('bofaVideoExperience');
      }
    });
    spartaEventsUtility.sub(spartaUILayersUtility.EVENTS.MODAL_CLOSED, resp => {
      const videoEl = resp.data.contentId;
      if (videoEl) spartaCinemaUtility.destroyVideo('spaCinema_bofaVideoExperience');
    });
  }
}
var index = new ModalUtility();

export { index as default };
